import { GuideOrderThemeSizeConfig } from './types';

const small: GuideOrderThemeSizeConfig = {
  guideOrder: {},
};

export default small;
